import { Component, Inject } from '@angular/core';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { MatTabsModule } from '@angular/material/tabs';
import { EncryptionService } from 'src/app/service/encryption.service';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { StorageService } from 'src/app/service/storage.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { Meta, Title } from '@angular/platform-browser';
import { GlobalValueService } from 'src/app/service/globalValue.service.';
import { LetsChatComponent } from "../lets-chat/lets-chat.component";
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-knowledgeBase-SubCategory',
    standalone: true,
    templateUrl: './knowledge-base-subCategory.component.html',
    styleUrls: ['./knowledge-base-subCategory.component.less'],
    imports: [NgFor, NgIf,MatTabsModule, NgxPaginationModule, LetsChatComponent]
})

export class KnowledgeBaseSubCategoryComponent {

  selected = 0;
  p: number = 1;

  childItem = [];
  mainBaseArray = [];
  questionsArray = [];
  subcategoryChild = [];
  titleArrayForKeywords = [];  
  
  categoryID: string;
  subCategory: string;
  mainCategory: string;
  subCategoryId: string;
  categoryTitles: string;

  shimmer = false;

  private routerSubscription: Subscription;
  private loadedArticleCategoryId: string;

  get activeSubCategory(): any {
    if (!this.subCategory || !Array.isArray(this.childItem) || this.childItem.length === 0) {
      return null;
    }

    return this.childItem.find(item => item.permalink === this.subCategory) ?? null;
  }

  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private meta: Meta,
    private router: Router,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    private storageService: StorageService,
    private constantService: ConstantService,
    private forumApiService: ForumApiService,
    private encryptionService: EncryptionService,
    private globalValueService: GlobalValueService    
  ) {}

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.mainCategory = params.get('cname') || '';
      this.subCategory = params.get('sname') || '';
      this.syncCategorySelection();
    });

    this.backNavigation();

    this.dataService.data.subscribe((mainBaseArray) => {
      if (!Array.isArray(mainBaseArray) || mainBaseArray.length === 0) {
        return;
      }

      mainBaseArray.forEach(mCategoryEle => {
        if(mCategoryEle.permalink === this.mainCategory) {
          this.childItem = mCategoryEle.child;
        }
      });

      this.syncCategorySelection();
      this.addMetaTag();
    });
    
  }

  private syncCategorySelection(): void {
    const subCategory = this.activeSubCategory;
    if (!subCategory) {
      return;
    }

    this.categoryID = subCategory.id;
    this.selectedMenuItem();

    if (subCategory.child.length === 0) {
      if (this.loadedArticleCategoryId !== subCategory.id) {
        this.loadedArticleCategoryId = subCategory.id;
        this.questionsArray = [];
        this.getArticalList(subCategory.id);
      }
    } else {
      this.questionsArray = [];
      this.shimmer = false;
    }
  }

  backNavigation() {
    try {
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {
            this.dataService.data.subscribe((mainBaseArray) => {
              if (!Array.isArray(mainBaseArray) || mainBaseArray.length === 0) {
                return;
              }

              mainBaseArray.forEach(mCategoryEle => {
                if(mCategoryEle.permalink === event.url.split("/")[1]) {
                  this.childItem = mCategoryEle.child;
                }
              });
              
              const subCategoryPermalink = event.url.split("/")[2];
              const selectedIndex = this.childItem.findIndex(
                element => element.permalink === subCategoryPermalink
              );

              if (selectedIndex >= 0) {
                this.selected = selectedIndex;
              }
            });
          }
        }
      });
    } catch (e) {
      console.log('Error in backNavigation method - ', e);
    }
  }

  addMetaTag(): void {
    try{
      this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.forumPageRobotContent });
      this.childItem.forEach((value) => { 
        this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + value.name;
        this.titleArrayForKeywords.push(value.name); 
       });
       var str = this.titleArrayForKeywords.join(", ");
       this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
       this.meta.updateTag({ name: this.constantService.keywords, content: str });
    }  catch(e){
      console.log('Error in addMetaTag method - ',e);
    } 
  }

  selectedMenuItem(): void {
    try{
      if (!this.categoryID || !Array.isArray(this.childItem) || this.childItem.length === 0) {
        return;
      }

      const selectedIndex = this.childItem.findIndex(value => this.categoryID == value.id);

      if (selectedIndex >= 0) {
        this.selected = selectedIndex;
        this.subCategoryId = this.childItem[selectedIndex].id;
        this.titleService.setTitle(
          this.constantService.getKnowledgeBasePageTitle(this.childItem[selectedIndex].name)
        );
      }
    } catch(e){
      console.log('Error in selectedMenuItem method - ',e);
    }
  }  

  async getArticalList(catId: string): Promise<void> {
    try {
      this.shimmer = true;
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const categoryId = catId;
      const from = this.constantService.getArticleListRequestConstant.galFrom
      const limit = this.constantService.getArticleListRequestConstant.galLimit;
      const sortBy = this.constantService.getArticleListRequestConstant.galSortBy;
      const locale = this.constantService.getArticleListRequestConstant.gallocale;
      ;
    
      await this.forumApiService.articalList(portalId, categoryId, from, limit, sortBy, locale).then(async (getArticalListResponse) => {
        this.shimmer = false;
        this.categoryTitles = '';
        for(let i=0; i<getArticalListResponse.data.length; i++){
          this.questionsArray[i] = getArticalListResponse.data[i];
          this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + getArticalListResponse.data[i].title;
          this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
        }
      });
    } catch (e) {
      this.shimmer = false;
      console.group('Error Occured in getArticalList : ', e);
    }
  }

  changeMenu(tabEvent: any): void {
    try{
      this.p = 1;
      this.selected = tabEvent.index;

      const tabCategory = this.childItem[tabEvent.index];
      if (!tabCategory) {
        return;
      }

      this.titleService.setTitle(
        this.constantService.getKnowledgeBasePageTitle(tabCategory.name)
      );
      this.router.navigateByUrl(this.mainCategory + '/' + tabCategory.permalink);
    } catch(e){
      console.log('Error in changeMenu method - ',e);
    }    
  }

  getValues(): { mainCategoryValue: any, subCategoryValue: any } {
    return {
      mainCategoryValue: this.globalValueService.mainCategory,
      subCategoryValue: this.globalValueService.subCategory
    };
  }

  setValues(value1: string, value2: string): void {
    try {
      this.globalValueService.mainCategory = value1;
      this.globalValueService.subCategory = value2;
    } catch(e){
      console.log('Error in setValues method - ',e);
    }
  }

  goTosubCategoryAnswers(questionId: string, questionTitle: string, subCatId: string): void {
    try{
      if(localStorage.getItem(this.constantService.isLoggedIn) == this.constantService.yes){
        const values = this.getValues();
        this.setValues(values.mainCategoryValue,subCatId);
      }
      this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
    } catch(e){
      console.log('Error in goTosubCategoryAnswers method - ',e);
    }
  }

  goToSubCategoryChild(subId: string, subCategoryChildName: string): void {
    try {
      this.router.navigateByUrl(this.mainCategory + '/' + this.subCategory + '/' + 'subCategory' + '/' + subCategoryChildName);
    } catch(e){
      console.log('Error in goToSubCategoryChild - ',e);
    }    
  }

  onNestedSubCategoryKeydown(event: KeyboardEvent, index: number): void {
    this.moveListFocus(event, index, 'kb-nested-subcategory-item');
  }

  onArticleKeydown(event: KeyboardEvent, index: number): void {
    this.moveListFocus(event, index, 'kb-article-item');
  }

  private moveListFocus(event: KeyboardEvent, index: number, idPrefix: string): void {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      document.getElementById(`${idPrefix}-${index + 1}`)?.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      document.getElementById(`${idPrefix}-${index - 1}`)?.focus();
    }
  }

}